import axios from 'axios';
import { siteUrl } from '../configs/config';

const authorization_prefix = 'Bearer ';
const apiToken = JSON.parse(localStorage.getItem('ApiToken_AyuRx'));


export const customHeaders = {
    Accept: 'application/json',
    // 'Content-Type': 'multipart/form-data',
    // 'Access-Control-Allow-Origin': '*',
    Authorization: `${authorization_prefix}${apiToken}`|| undefined
};

export default axios.create({
    baseURL: siteUrl,
    headers: customHeaders,
});